import { render, staticRenderFns } from "./VNewlines.vue?vue&type=template&id=7c655fac&"
import script from "./VNewlines.vue?vue&type=script&lang=js&"
export * from "./VNewlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports